import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { MatButtonToggleGroup } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";
import { FormControl } from "@angular/forms";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { GroupOrderCreateGroupService } from "./groupOrderCreateGroup.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import Utils from "../../shared/utils";
import { Observable, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { ErrorValidationComponent } from "../../directives/errorValidation/errorValidation.component";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { WarningdialogComponent } from "../../modalDialogs";
import { IGroupName, CreateGroupResult } from "./groupOrderCreateGroup.facade";
import { RouterHelperService } from "../../services/routerHelper.service";
import { UserHelperService } from "../../services/userHelper.service";
import { UserProfileService } from "../userProfile/userprofile.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { forbiddenNameValidator, ValidatorsConfig } from "../../shared/validator/validator.function";
import { WebShopService } from "../../services/webShop.service";
import { FieldName } from "../../shared/validator/validatorMessage.interface";
import { INHOUSE_GROUPORDER_NAME_ERROR_MESSAGES } from "../../shared/validator/validatorErrorMessages";

@Component({
  selector: "groupOrderCreateGroup",
  templateUrl: "./groupOrderCreateGroup.component.html",
  styleUrls: ["./groupOrderCreateGroup.component.scss"],
  providers: [GroupOrderCreateGroupService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class GroupOrderCreateGroupComponent implements OnInit, OnDestroy {
  @ViewChild("toggleGroupName") toggleGroupName: MatButtonToggleGroup;
  @ViewChild("errorValidation") errorValidation: ErrorValidationComponent;

  public proposedGroupNames$: Observable<IGroupName[]>;
  public hasProposedGroupNames$: Observable<boolean>;
  public groupExists$: Observable<boolean>;
  public canCreateGroup$: Observable<boolean>;
  public selectedGroupName: string = "";
  public inputGroupName: string = "";
  public inputUserNickname: string = "";
  public isLogin: boolean = false;
  public tableQrCode: string;

  private _langSubscriber: Subscription;
  private _groupNameInputSubscriber: Subscription;
  private _groupNameToggleSubscriber: Subscription;
  private _groupNamevalidationSubscriber: Subscription;
  private _userNameInputSubscriber: Subscription;
  private _userNamevalidationSubscriber: Subscription;

  /** Validate user input (group name)*/
  public groupNameInputFormControl = new FormControl('', {
    validators: ValidatorsConfig.forGroupMemberName(),
    asyncValidators: forbiddenNameValidator(this._webShopService)
  });

  /** Validate user input (user name)*/
  public userNameInputFormControl = new FormControl('', {
    validators: ValidatorsConfig.forGroupMemberName(),
    asyncValidators: forbiddenNameValidator(this._webShopService)
  });

  public isSmallView: boolean = false;
  public field = FieldName;

  private tablecode: string = null;

  constructor(private _location: Location
    , private _router: Router
    , private _webShopService: WebShopService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private _internationalisationService: InternationalisationService
    , private _groupOrderCreateGroupService: GroupOrderCreateGroupService
    , private _iosHelperService: IOSHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _activatedRoute: ActivatedRoute
    , private _userProfileService: UserProfileService
    , private _userHelpService: UserHelperService
    , private _routerHelperService: RouterHelperService
    , private _overlaySpinnerService: OverlaySpinnerService) {
    const me = this;
    me.isSmallView = me._mainnavService.viewType === ViewType.Small;

    me.proposedGroupNames$ = me._groupOrderCreateGroupService.proposedGroupNames$;
    me.hasProposedGroupNames$ = me._groupOrderCreateGroupService.hasProposedGroupNames$;
    me.groupExists$ = me._groupOrderCreateGroupService.groupExists$;
    me.canCreateGroup$ = me._groupOrderCreateGroupService.canCreateGroup$;
  }


  ngOnDestroy(): void {
    const me = this;
    if (me._groupNameToggleSubscriber) {
      me._groupNameToggleSubscriber.unsubscribe();
    }
    if (me._groupNameInputSubscriber) {
      me._groupNameInputSubscriber.unsubscribe()
    }
    if (me._userNameInputSubscriber) {
      me._userNameInputSubscriber.unsubscribe();
    }
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe()
    }
    if (me._groupNamevalidationSubscriber) {
      me._groupNamevalidationSubscriber.unsubscribe()
    }
    if (me._userNamevalidationSubscriber) {
      me._userNamevalidationSubscriber.unsubscribe()
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("GroupOrderCreateGroupComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;

    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData) {
      me.tablecode = routeTargetData["tablecode"];
    }

    if (!me.tablecode) {
      me._coreLogService.error("GroupOrderCreateGroupComponent.ngOnInit", "no tablecode");
      me._router.navigate(["/"]); // back to home
      return; // exit here
    }

    me._groupOrderCreateGroupService.initial(me.tablecode).then(() => {
      me.PushChanges();
    });

    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    me._groupNameToggleSubscriber = me.toggleGroupName.valueChange.subscribe(() => {
      me.selectedGroupName = me.toggleGroupName.value;
      me.PushChanges();
    });

    /** get latest validation status of that control whenever validation status is recalculated for that control. */
    me._groupNamevalidationSubscriber = me.groupNameInputFormControl.statusChanges.subscribe(() => {
      me.PushChanges();
    });

    /** get latest value of that control whenever there is any change. */
    me._groupNameInputSubscriber = me.groupNameInputFormControl.valueChanges.subscribe(() => {
      me.groupNameInputFormControl.markAsTouched();
      me.inputGroupName = me.groupNameInputFormControl.value;
      me.ClearToggleValue();

      me.PushChanges();
    });

    /** get latest validation status of that control whenever validation status is recalculated for that control. */
    me._userNamevalidationSubscriber = me.userNameInputFormControl.statusChanges.subscribe(() => {
      me.PushChanges();
    });
    me._userNameInputSubscriber = me.userNameInputFormControl.valueChanges.subscribe(() => {
      me.inputUserNickname = me.userNameInputFormControl.value;
      me.userNameInputFormControl.markAsTouched();
      me.PushChanges();
    })
    me.GetUserProfileName();
  }

  //set group name input placeholder
  public get inputPlaceholder(): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_Create_GroupNameInput_PlaceHolder");
  }

  /** toggle group names*/
  public SelectToggleGroupName(event) {
    const me = this;
    const toggle = event.source;
    if (toggle) {
      if (event.value === me.toggleGroupName.value) {
        me.ClearInputValue();
        me.selectedGroupName = me.toggleGroupName.value;
      } else {
        me.toggleGroupName.value = ""
        me._coreLogService.error("GroupOrderCreateGroupComponent.SelectToggleGroupName", "event.value has no me.toggleGroupName.value", event.value, me.toggleGroupName.value);
      }
    } else {
      me.toggleGroupName.value = ""
    }
  }

  /** Clear input value if input value is not empty and toggle selected */
  public ClearInputValue() {
    const me = this;
    if (!Utils.IsNullOrEmpty(me.inputGroupName)) {
      me.groupNameInputFormControl.setValue("");
    }
    me.groupNameInputFormControl.markAsUntouched();
    me.PushChanges();
  }//else do nothing


  /** Clear toggle value if toggle is selected and input value is not empty*/
  public ClearToggleValue() {
    const me = this;
    if (me.groupNameInputFormControl.touched && !Utils.IsNullOrEmpty(me.groupNameInputFormControl.value)) {
      if (!Utils.IsNullOrEmpty(me.selectedGroupName)) {
        me.toggleGroupName._buttonToggles.forEach(i => i.checked = false);
        me.PushChanges();
      }
    }
  }
  /** set selected/input group name*/
  public GetGroupName(): string {
    const me = this;
    let group_name = "";
    if (!Utils.IsNullOrEmpty(me.selectedGroupName)) {
      group_name = me.selectedGroupName;
    } else {
      group_name = me.inputGroupName;
    }
    return group_name;
  }

  public get nameInputPlaceholder(): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_GroupCreated_UserName_Input_placeholder")
  }
  /** Get user name and set*/
  public GetUserProfileName(): string {
    const me = this;
    me.isLogin = me._userHelpService.IsRegistered;
    me.inputUserNickname = me.userNameInputFormControl.value;
    if (me.isLogin) {
      me._userProfileService.GetUserInfoViewModel()
        .then(async (userViewModel) => {
          me.inputUserNickname = userViewModel.fname;
          me.userNameInputFormControl.setValue(me.inputUserNickname);
          me.PushChanges();
        })
        .catch(e => {
          me._coreLogService.error("GroupOrderCreateGroupComponent.GetUserProfileName", "GetUserInfoViewModel", e);
        });
    } else {
      me.inputUserNickname = "";
    }
    return me.inputUserNickname;
  }

  public setUserName(): string {
    const me = this;
    if (Utils.IsNullOrEmpty(me.inputUserNickname)) {
      me.inputUserNickname = me.userNameInputFormControl.value;
    }
    return me.inputUserNickname;
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /**navigate to scan group-code */
  public joinGroup() {
    const me = this;
    me._routerHelperService.setRouteTargetDataByKey("isGroupOrder", true);
    me._routerHelperService.setRouteTargetDataByKey("tablecode", me.tablecode);
    me._router.navigate(["/qrcodescanner"]);
  }

  /** Navigate to success page*/
  public async CreateGroupAndNavigate(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    let canCreateGroup = false;
    me._groupOrderCreateGroupService.canCreateGroup$.pipe(take(1)).subscribe(value => canCreateGroup = value).unsubscribe();
    if (canCreateGroup) {
      const createResponse = await me._groupOrderCreateGroupService.createGroup(me.GetGroupName(), me.setUserName());
      me._overlaySpinnerService.HideLayoutSpinner();
      switch (createResponse) {
        case CreateGroupResult.Okay:
          me._router.navigate(["/groupOrderGuide"]);
          break;
        case CreateGroupResult.TableFull:
          me.OpenWarningMaxGroupCountReached();
          break;
        case CreateGroupResult.WrongGroupName:
          me.OpenWarningCreateGroupNameFailed();
          break;
        case CreateGroupResult.WrongUserName:
          me.OpenWarningCreateUserNameFailed();
          break;
        case CreateGroupResult.Fail:
          me.OpenWarningCreateGroupFailed();
          break;
        default:
          me.OpenWarningCreateGroupFailed();
          me._coreLogService.error("GroupOrderCreateGroupComponent.CreateGroupAndNavigate", "unknown CreateGroupResult", createResponse);
          break;
      }
    } else {
      me.OpenWarningMaxGroupCountReached();
    }
  }

  public setBtnStateByGroupName(): boolean {
    const me = this;
    return !Utils.IsNullOrEmpty(me.toggleGroupName.value) || me.groupNameInputFormControl.touched && this.groupNameInputFormControl.valid ? true : false
  }

  public setBtnStateByUserName(): boolean {
    const me = this;
    return !Utils.IsNullOrEmpty(me.userNameInputFormControl.value) && me.userNameInputFormControl.valid ? true : false;
  }

  /** Get active error message for a form control based on field type */
  public activeError(control: FormControl, fieldName: FieldName): string | null {
    return ValidatorsConfig.getActiveErrorMessage(control, INHOUSE_GROUPORDER_NAME_ERROR_MESSAGES, fieldName);
  }

  /** Warning dialog: Max count reached  */
  private OpenWarningMaxGroupCountReached() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_GroupMaxCount_Dialog_Title"
        , content: "phGroupOrder_GroupMaxCount_Dialog_SubText"
        , btnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/menuservice"]);
      }
    });
  }

  /** Warning dialog: Max count reached  */
  private OpenWarningCreateGroupFailed() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_CreateGroup_Failed_Title"
        , content: "phGroupOrder_CreateGroup_Failed_SubText"
        , btnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/"]);//home
      }
    });
  }

  /** Warning dialog: groupname  */
  private OpenWarningCreateGroupNameFailed() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_CreateGroup_GroupName_Failed_Title"
        , content: "phGroupOrder_CreateGroup_Name_Failed_SubText"
        , btnLabel: "phGlobal_Return"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  /** Warning dialog: user name  */
  private OpenWarningCreateUserNameFailed() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_CreateGroup_UserName_Failed_Title"
        , content: "phGroupOrder_CreateGroup_Name_Failed_SubText"
        , btnLabel: "phGlobal_Return"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    const me = this;
    if (me.tablecode) {
      me._routerHelperService.setRouteTargetDataByKey("tablecode", me.tablecode);
      me._router.navigate(["/orderModeSelector"]);
    } else {
      me._location.back();
    }
  }
}